<template>
  <div class="container py-10">
    <transition name="fade" mode="out-in">
      <div v-if="submitted" class="text-center py-10">
        <h2>Successfully Submitted</h2>
        <p>Your form has been submitted and will be processed soon.</p>
        <d-btn href="https://awiqcp.org/" style="margin-top: 15px">
          Return Home
        </d-btn>
      </div>
      <div v-else class="flex flex-wrap -mx-5">
        <div class="w-full md:w-5/12 lg:w-4/12 px-5">
          <h1 class="font-bold text-primary-500 text-3xl">
            Request a QCP Project Inspection
          </h1>
          <p class="mb-5">
            Inspections are available for any project in which QCP was specified in the contract documents, and the following three criteria have been met:
            <ol>
              <li>The project was registered with the QCP office prior to the commencement of fabrication.</li>
              <li>The manufacturer/supplier/installer is a current participant in the QCP.</li>
              <li>The 1/2% label fee has been paid.</li>
            </ol>
          </p>
          <p class="mb-5">
            <a href="https://awiqcp.org/wp-content/uploads/2018/10/label-form.pdf">Download a Sample Project Compliance Inspection Report (PDF).</a>
          </p>
          <p class="mb-5">
            To arrange a QCP project inspection, simply complete the form and we will contact you to discuss your inspection request. You may also <a href="https://awiqcp.org/contact/">contact QCP directly.</a>
          </p>
        </div>
        <div class="w-full md:w-7/12 lg:w-8/12 px-5">
          <page-one v-if="currentPage == 1" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import PageOne from './components/RequestInspection/PageOne.vue';


  const { mapGetters } = createNamespacedHelpers('requestInspectionForm');

  export default {
    parent: true,
    components: {
      PageOne,
    },


    computed: {
      ...mapGetters([
        'currentPage',
        'submitted',
      ]),
    },
  };
</script>